import React from 'react';
export function OfferSection() {
  return <div className="max-w-3xl mx-auto px-4 py-8" data-id="element-94">
      <div className="my-8" data-id="element-95">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bmFrBEweGVKAo4eb7jMHSR/WhatsApp_Image_2025-11-30_at_23.21.40_3770a1dc.jpg" alt="Happy dog owner enjoying quality time with healthy dog" className="w-full h-auto rounded-lg shadow-md" data-id="element-96" />
        <p className="text-center text-sm text-gray-500 mt-2" data-id="element-97">
          Living your best life together - what every dog owner wants
        </p>
      </div>

      <div className="bg-gray-100 p-8 rounded-lg text-center" data-id="element-98">
        <h2 className="text-xl font-bold mb-4" data-id="element-99">
          Special Offer for New Customers
        </h2>

        <div className="bg-yellow-100 p-4 rounded-lg mb-6 font-bold text-lg" data-id="element-100">
          LIMITED TIME: Buy 2 Get 1 Free + 40% Off
        </div>

        <p className="mb-6" data-id="element-101">
          Stock up and save! Get 3 bottles for the price of 2, plus an
          additional 40% off your entire order. No questions asked.
        </p>

        <div className="flex justify-center mb-6" data-id="element-102">
          <a href="https://hushpups.co/products/melao-dental-formula" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg transition-colors duration-300" data-id="element-103">
            CLAIM YOUR OFFER NOW →
          </a>
        </div>
      </div>

      <div className="mt-10 mb-6" data-id="element-104">
        <p className="mb-4" data-id="element-105">
          I'm not a vet. I'm just a dog mom who refused to accept that expensive
          cleanings and daily wrestling matches were my only options.
        </p>
        <p className="mb-4" data-id="element-106">
          If you're tired of feeling guilty about your dog's teeth... if you
          want to actually solve the problem instead of just managing it...
        </p>
        <p className="mb-6" data-id="element-107">Melao™ might be worth exploring.</p>
        <p className="mb-6" data-id="element-108">
          To your dog's health,
          <br data-id="element-109" />
          Sarah Mitchell
        </p>
      </div>

      <div className="border-t border-gray-300 pt-6 text-xs text-gray-600" data-id="element-110"></div>
      <div className="my-8" data-id="element-111"></div>
    </div>;
}